export const SPACINGS = [
  '4px',
  '8px',
  '16px',
  '24px',
  '32px',
  '40px',
  '48px',
  '56px',
  '64px',
  '72px',
  '80px',
  '88px',
  '96px',
  '104px',
  '112px',
  '120px',
  '128px',
  '136px',
  '144px',
  '152px',
  '160px',
  '168px',
  '176px',
  '184px',
  '192px',
  '200px',
]

export const SHADOWS = {
  cardShadow: '0 0px 25px rgba(0, 0, 0, 0.08)',
}

export const values = {
  xs: 350,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 2000,
  xxxxxl: 2500,
}

export const BREAKPOINTS = {
  xs: `(min-width: ${values.xs}px)`,
  sm: `(min-width: ${values.sm}px)`,
  md: `(min-width: ${values.md}px)`,
  lg: `(min-width: ${values.lg}px)`,
  xl: `(min-width: ${values.xl}px)`,
  xxl: `(min-width: ${values.xxl}px)`,
  xxxl: `(min-width: ${values.xxxl}px)`,
  xxxxl: `(min-width: ${values.xxxxl}px)`,
}

export const families = {
  light: 'MaerskTextLight',
  regular: 'MaerskTextRegular',
  bold: 'MaerskTextBold',
  headlines: {
    light: 'MaerskHeadlineLight',
    regular: 'MaerskHeadlineRegular',
    bold: 'MaerskHeadlineBold',
  },
}

export const sizes = {
  xxs: '0.625rem', // 10px
  xs: '0.75rem', // 12px
  sm: '0.875rem', // 14px
  md: '1rem', // 16px
  lg: '1.25rem', // 20px
  xl: '1.5rem', // 24px
  xxl: '2rem', // 32px
  xxxl: '2.5rem', // 40px
}

export const lineHeights = {
  sm: '1.25rem', // 20px
  md: '1.5rem', // 24px
}

export const weights = {
  light: '300',
  normal: '400',
  bold: '700',
}

export const FONTS = {
  families,
  sizes,
  lineHeights,
  weights,
}

export const COLORS = {
  // https://www.figma.com/file/QhfggJEHll1vYv3Z6bSw7P/Maersk-Tankers-Design-System?node-id=14%3A1692&t=AR03HYmyNkPftqAQ-0
  primary: {
    maerskBlue: '#42b0d5ff',
    white: '#ffffffff',
    deepBlue: '#003e5eff',
    webFont: '#292929',
  },
  secondary: {
    barBlue: '#0fa0d1ff',
    darkBlue: {
      primary: '#00243dff',
      secondary: '#193850ff',
    },
    hoverBlue: '#57b9daff',
    midBlue: '#0073abff',
    lightBlue: {
      primary: '#b5e0f4ff',
      tint: '#f0f9fdff',
    },
    actionBlue: '#61c8ebff',
    notificationBlue: '#deedf4ff',
  },
  greys: {
    dark: '#6c7f8dff',
    mid: '#b3bdc5ff',
    light: '#e3e8ecff',
    ultraLight: '#f7f8f9ff',
  },
  citrus: {
    mid: {
      primary: '#a3bf00ff',
      tint2: '#d5de8cff',
      tint3: '#e8efc2ff',
    },
  },
  orange: {
    tint5: '#F6DEC4ff',
    dark: {
      primary: '#a76d46ff',
    },
    mid: {
      tint3: '#f9d28bff',
    },
    light: {
      primary: '#ffa201ff',
      tint2: '#eebd8bff',
    },
  },
  red: {
    dark: {
      primary: '#6b0d05ff',
      secondary: '#B80012ff',
    },
    mid: {
      primary: '#fa381cff',
      tint2: '#f9dcd4ff',
      tint3: '#fcefebff',
    },
    light: {
      primary: '#ee9f92ff',
      tint1: '#f9d8d3ff',
      tint2: '#f9dcd4ff',
      tint3: '#fcefebff',
    },
  },
  green: {
    mid: {
      primary: '#4db5abff',
    },
    light: {
      primary: '#e8f4f2ff',
      tint3: '#00786bff',
    },
  },
  feedback: {
    yellow: {
      warning: '#ffcc00',
    },
    red: {
      error: '#ff0000',
    },
    blue: {
      notification: '#4da6ff',
    },
  },
}

export const theme = {
  SPACINGS,
  SHADOWS,
  values,
  BREAKPOINTS,
  families,
  sizes,
  lineHeights,
  weights,
  FONTS,
  COLORS,
}
